import { render } from "./Breadcrumb.vue?vue&type=template&id=4666c652&scoped=true"
import script from "./Breadcrumb.vue?vue&type=script&lang=js"
export * from "./Breadcrumb.vue?vue&type=script&lang=js"

import "./Breadcrumb.vue?vue&type=style&index=0&id=4666c652&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4666c652"

export default script